import { render, staticRenderFns } from "./ScoreDetail.vue?vue&type=template&id=142b7d44"
import script from "./ScoreDetail.vue?vue&type=script&lang=js"
export * from "./ScoreDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports